<template>
  <section>
      <div class="columns is-multiline" style="overflow:none!important">
        <div class="column is-4 p-0">
          <img src="@/assets/img/obras/fotos/4.jpg" class="width100 is-block">
        </div>
        <div class="column is-4 p-0">
          <img src="@/assets/img/obras/fotos/5.jpg" class="width100 is-block">
        </div>
        <div class="column is-4 p-0">
          <img src="@/assets/img/obras/fotos/6.jpg" class="width100 is-block">
        </div>                
    </div>
  </section>
</template>

<script>
export default {
  name: 'Slider',
  data () {
    return {
        progress: true,
        progressType: 'is-primary',
    }
  }
}
</script>
